import React, { useState } from 'react';
import { Popover, Tooltip } from '~/ui/components';
import { TooltipPlacement, TooltipTrigger } from 'antd/lib/tooltip';
import { ActionButton, Option, OptionsList } from './MenuOptions.styled';

export type OptionProps = {
  icon?: string;
  label: string | React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  tooltip?: string;
  key?: string;
};

type MenuOptionsProps = {
  placement?: TooltipPlacement;
  trigger?: TooltipTrigger;
  onChangeVisibility?: (visible: boolean) => void;
  width?: number | string;
  options: OptionProps[];
  children?: React.ReactNode;
  closeOnClick?: boolean;
  disabled?: boolean;
};

export function MenuOptions({
  placement,
  trigger,
  onChangeVisibility,
  width,
  options,
  children,
  closeOnClick = true,
  disabled,
  ...props
}: MenuOptionsProps) {
  const [visible, setVisible] = useState(false);

  const handleVisibleChange = (visible: boolean) => {
    setVisible(visible);
    onChangeVisibility?.(visible);
  };

  const handleOptionClick = (option) => () => {
    if (closeOnClick) {
      handleVisibleChange(false);
    }
    option?.onClick?.();
  };

  return (
    <Popover
      placement={placement || 'bottomRight'}
      trigger={trigger || 'click'}
      onVisibleChange={handleVisibleChange}
      visible={visible}
      width={width || 258}
      noPadding
      noHeader
      disabled={disabled}
      {...props}
      content={
        <OptionsList data-testid="menu-options-content">
          {options?.map((option) => {
            const optionKey = option.key || String(option.label);
            const optionButton = (
              <Option disabled={option.disabled} icon={option.icon} onClick={handleOptionClick(option)}>
                {option.label}
              </Option>
            );

            if (!option.tooltip) {
              return React.cloneElement(optionButton, { key: optionKey });
            }

            return (
              <Tooltip key={optionKey} content={option.tooltip}>
                <div style={{ width: '100%' }}>{optionButton}</div>
              </Tooltip>
            );
          })}

          {!options?.length && (
            <Option disabled>
              <span>Nenhuma opção disponível</span>
            </Option>
          )}
        </OptionsList>
      }
    >
      {children || <ActionButton />}
    </Popover>
  );
}
